import React, { useEffect, useState } from 'react';
import './Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

import factoids from '../../info/factoids';
import FactoidSection from '../../components/FactoidSection';

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionMedicalImaging.mp4",
    poster: "/videos/solutionMedicalImaging.jpg",
    heading: "Sharper Medical Images Begin with Superior Optics",
    subheading: "Where innovation meets precision",
    buttonLink: "/support"
  }
];

function SolutionMedicalImaging() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');



const productFamilies = [
  'Lenses',
  'Collimators & Probes',
  'Passive Optical Components',
];

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products

const [familyIndex, setFamilyIndex] = useState(0);
const [familySlidesPerView, setFamilySlidesPerView] = useState(3);

useEffect(() => {
  const update = () => {
    if (window.innerWidth <= 768) {
      setFamilySlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setFamilySlidesPerView(2);
    } else {
      setFamilySlidesPerView(3);
    }
  };

  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);

const familyMaxIndex = Math.max(topByFamily.length - familySlidesPerView, 0);

const nextFamily = () => {
  setFamilyIndex(prev => Math.min(prev + 1, familyMaxIndex));
};

const prevFamily = () => {
  setFamilyIndex(prev => Math.max(prev - 1, 0));
};

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={slides[0].buttonLink} className="cta-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-1" style={{ marginTop: 50}}>
        <div className="solutions-section-1-image-container">
          <img src="/images/solutions/medicalImaging.jpeg" alt="Medical Imaging" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Advanced optics are redefining internal medical imaging</h2>
          <p className="solution-section-1-description">In the increasingly complex field of medical imaging, clinicians and researchers face tremendous challenges in pinpointing the precise location and composition of tiny vessels with clarity, especially in internal applications such as cardiac and esophageal imaging using optical coherence tomography (OCT). The need for miniaturized, disposable, high-performance optical systems is greater than ever, as traditional solutions struggle to overcome issues of resolution, depth, and efficiency. Today’s medical imaging demands not only superior image quality but also a strong quality system that supports rapid, high-volume manufacturing at competitive cost. That’s Go!Foton.</p>
        </div>
      </div>

      <FactoidSection
        solution="medical-imaging"
        title="Medical imaging & OCT Trends"
        description=""
      />

      <div className="solutions-section-checklist">
        <div className="solutions-section-checklist-left">
          
          <div className="solutions-section-checklist-image-wrapper">
            <img src="/images/solutions/medicalImaging2.jpeg" alt="Medical Imaging" />
          </div>
        </div>

        <div className="solutions-section-checklist-right">
          <h2 className="solutions-section-checklist-heading">Engineered for exceptional image quality in medical imaging</h2>
          <p className="solutions-section-checklist-description">From rapid manufacturing cycles to scalable, customizable designs, Go!Foton’s advanced optical solutions directly address the critical challenges of medical imaging. Go!Foton solutions deliver exceptional image quality and transformative diagnostic clarity. Our quality solutions ensure that every device not only meets but exceeds clinical performance standards, empowering healthcare providers with high-value solutions that are engineered for excellence and innovation.</p>
          <ul className="solutions-section-checklist-points">
            <li>Image Quality</li>
            <li>High-value solutions</li>
            <li>Engineering excellence</li>
            <li>Innovation</li>
          </ul>
        </div>
      </div>


    <section className="solution-products-section">
      <h2>Next-generation medical imaging solutions</h2>
      <p className="solution-products-section-description">Discover the future of medical imaging with our next-generation solutions, engineered with a robust, manufacturing-grade quality to empower clinicians and researchers with exceptional image clarity and operational reliability.</p>


<div className="products-grid">
  {topByFamily.map(({ family, topProduct }) => (
    <div key={family} className="product-card">
      {topProduct.image ? (
        <img
          src={topProduct.image}
          alt={family}
          style={{ width: '100%', height: 200, objectFit: 'cover' }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: 215,
            backgroundColor: '#ddd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontStyle: 'italic',
            color: '#666',
          }}
        >
          No Image Available
        </div>
      )}
      <h3>{family}</h3>
      <a
        href={`/${family.toLowerCase().replace(/\s+/g, '-')}`}
        className="learn-more"
      >
        Learn More
      </a>
    </div>
  ))}
</div>

    </section>

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default SolutionMedicalImaging;
